import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getMasReport = async(param:any )=>{
   const response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_MAS_REPORT}`,{params:param});
   const rowData = await response?.data;   
  //  console.log('MAsReport---row---Data',rowData?.data?.data)
   
   
const formatedData = Array.isArray(rowData?.data?.data)
  ? rowData.data.data.map((item: any) => ({
      orgunit: item.OrgUnitName,
      repcode: item.RepCode,
      employeecode: item.EmployeeCode,
      employeename: item.EmployeeName,
      amname: item.AmPosition,         // your column "AM Name"
      rmname: item.RmPosition,         // your column "RM Name"
      zmname: item.ZmPosition,         // your column "ZM Name"
      location: item.Location,
      workingdays: item.WorkingDays,
      fwd: item.Fwd,
      nca: item.Nca,
      totaldoctors: item.TotalDoctors,
      drmet: item.DrMet,
      drvfmet: item.DrVfMet,
      drcal: item.DrcaL,
      drcvrg: item.Drcvrg,
      drvforvg: item.Drvfcvrg,         // ✅ matched with API
      misseddr: item.MissedDr,
      misseddrcalls: item.MissedDrCalls,
      totalchemist: item.TotalChemist,
      pobvalue: item.PobValue,
      rcpaownbrand: item.RcpaValueForOwnBrand,
      rcpacompbrand: item.RcpaValueForCompBrand,
      jointworktotalcalls: item.JointWorkTotalCalls,
      leavedays: item.LeaveDays,
      jointworking: item.JointWorking,
      nodrcall: item.NoDrCall,
      agenda: item.Agenda,
      zmpositioncode: item.ZmPositionCode,
      rmpositioncode: item.RmPositionCode,
      ampositioncode: item.AmPositionCode,
      employeestatus: item.EmployeeStatus,
      employeepositioncode: item.EmployeePositionCode,
      employeepositionname: item.EmployeePositionName,
      employeelevel: item.EmployeeLevel,
      chemistmet: item.ChemistMet,
      chemistcalls: item.ChemistCalls,
      chemistcallavg: item.ChemistCallAvg,
      totalstockist: item.TotalStockists,
      draddition: item.DrAddition,
      drdeletion: item.DrDeletion,
    }))
  : [];
//    console.log('formatedData',formatedData);
 return{rowData,formatedData};
}